export * from './fixed-summary-container.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/fixed-summary-container/index.ts